<template>
  <div class="content">
    <EsForm>
      <template #es-form>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Location Name</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-model="name"
                class="input"
                :class="{ 'is-danger': hasErrorName }"
                type="text"
                placeholder="Enter Location Name"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="200">
              <p class="help is-danger">{{ nameMsg }}</p>
            </div>
          </div>
        </div>
      </template>
    </EsForm>
    <es-form>
      <template #es-form>
        <div class="field is-grouped flex-justify--end">
          <div class="control is-flex flex-align--center">
            <a @click="resetForm">Reset</a>
          </div>
          <div class="control">
            <button
              class="button is-primary"
              @click.stop.prevent="formValidation"
              :disabled="loading"
            >
              Search
            </button>
          </div>
        </div>
      </template>
    </es-form>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';

library.add(faTimes);

export default {
  components: {
    EsForm,
    EsFormActions,
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      name: null,
      searchSource: 'advancedSearch',
      nameMsg: null,
      hasErrorName: false,
    };
  },
  watch: {
    $route: 'checkQuery',
  },
  created() {
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      const { query } = this.$route;

      if (query.name) {
        this.name = query.name;
      }
    },
    search() {
      const { query } = this.$route;

      if (query.name === this.name) {
        return;
      }

      this.$router.push(
        {
          name: 'locationSearch',
          query: {
            searchSource: this.searchSource,
            name: this.name,
          },
        },
      );
    },
    formValidation() {
      this.resetErrors();
      let errors = 0;
      if (!this.name) {
        errors += 1;
        this.nameMsg = 'Name is required.';
        this.hasErrorName = true;
      }
      if (errors === 0) {
        this.search();
      }
    },
    resetErrors() {
      this.hasErrorName = false;
      this.nameMsg = null;
    },
    resetForm() {
      this.resetErrors();
      this.name = '';

      if (Object.entries(this.$route.query).length) {
        this.$router.push(
          {
            name: 'locationSearch',
          },
        );
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 828px
    margin: auto
  .reset
    width: 30px
  li
    border-left: 0 !important
</style>
